import { render, staticRenderFns } from "./MaterialList.vue?vue&type=template&id=0dabc252&scoped=true"
import script from "./MaterialList.vue?vue&type=script&lang=js"
export * from "./MaterialList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dabc252",
  null
  
)

export default component.exports